export const transformComuniV2Result = result => {
  const searchLuogoNascita = result.reduce((acc, o) => {
    if (o.type === 'comune') {
      const comuneLabel = `${o.comune} (${o.codice_provincia})`
      // if (!state.searchLuogoNascita.find(el => el.label === comuneLabel)) {
      acc.push({
        label: comuneLabel,
        // prettier-ignore
        value: `${o.comune  }|${  o.codice_provincia  }|ITA|${  o.comune  } (${  o.codice_provincia  })|${  o.zip ? o.zip.replace(/, /g, "|") : ""  }|${  o.land_register}`,
      })
      // }
    }
    if (o.type === 'nazione') {
      const nazioneLabel = `${o.name} (EE)`
      // if (!state.searchLuogoNascita.find(el => el.label === nazioneLabel)) {
      acc.push({
        label: nazioneLabel,
        // prettier-ignore
        value: `${o.name}|EE|${  o.iso  }|${  nazioneLabel  } (EE)|${  o.land_register}`,
      })
      // }
    }
    return acc
  }, []) // .concat(state.searchLuogoNascita)

  return searchLuogoNascita
}

export const transformLicenseV2Result = result =>
  result.map(o => ({
    label: `${o.name} (${o.code})`,
    value: `${o.name} (${o.code})`,
  }))

export const transformPassportV2Result = result =>
  result.province.map(o => ({
    label: `${o.name} (${o.code})`,
    value: `${o.name} (${o.code})`,
  }))

export const transformIdentityCardV2Result = result =>
  result.map(o => ({
    label: `${o.comune} (${o.codice_provincia})`,
    value: `${o.comune} (${o.codice_provincia})`,
  }))

export const transformComuniCittadinanzaV2Result = result => {
  const cittadinanza_is_extra_eu_by_codice = {}

  const cittadinanza = result.map(o => {
    cittadinanza_is_extra_eu_by_codice[o.iso] = o.flag_extraue !== 'no'
    return { label: o.cittadinanza, value: `${o.iso}|${o.cittadinanza}` }
  })

  return {
    cittadinanza,
    cittadinanza_is_extra_eu_by_codice,
  }
}

export const transformComuniResidenzaV2Result = result => {
  const searchComuneResidenza = result.reduce((acc, o) => {
    const comuneLabel = `${o.comune} (${o.codice_provincia})`
    acc.push({
      label: comuneLabel,
      // prettier-ignore
      value: `${o.comune  }|${  o.codice_provincia  }|ITA|${  o.comune  } (${  o.codice_provincia  })|${  o.zip ? o.zip.replace(/, /g, "|") : ""  }|${  o.land_register}`,
    })

    return acc
  }, [])

  return searchComuneResidenza
}

export const transformComuniNazioniDefaultValue = stringPipedValue => {
  // stringPipedValue Milano|MI|ITA|Milano (MI)|20133|2013.....
  // stringPipedValue Austria|EE|AUT|Austria (EE) (EE)|Z102....

  if (!stringPipedValue) {
    return null
  }

  const splitted = stringPipedValue.split('|')
  if (!splitted.length) {
    return null
  }

  return {
    label: `${splitted[0]} (${splitted[1]})`,
    value: stringPipedValue,
  }
}

export const transformCittadinanzaDefaultValue = stringPipedValue => {
  // stringPipedValue AUT|austriaca

  if (!stringPipedValue) {
    return null
  }

  const splitted = stringPipedValue.split('|')
  if (!splitted.length) {
    return null
  }

  return {
    label: `${splitted[1]}`,
    value: stringPipedValue,
  }
}
export function getCodiceCastale(name) {
  const splitArray = name.split('|')
  return splitArray[splitArray.length - 1]
}
